import React from 'react';
export var Facebook = function Facebook() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#3B5998",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7266 7.38281C15.4883 7.38281 16.499 7.38281 16.499 7.38281V4.73633C16.499 4.73633 15.4346 4.73633 13.9893 4.73633C12.544 4.73633 10.6641 5.66406 10.6641 8.35938C10.6641 8.8623 10.6641 9.59961 10.6641 10.459H8.2666V13.1982H10.6641C10.6641 16.6113 10.6641 20.3271 10.6641 20.3271H11.7285H12.5733H13.5254C13.5254 20.3271 13.5254 16.4795 13.5254 13.1982H15.9082L16.3037 10.459H13.5254C13.5254 9.56055 13.5254 8.90625 13.5254 8.71582C13.5254 7.81738 13.9649 7.38281 14.7266 7.38281Z",
    fill: "white",
    stroke: "none"
  }));
};